"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tlIconButton", function (uiUtils, iconUtils) {
  return {
    restrict: "E",
    scope: false,
    replace: true,
    transclude: true,
    template: function template(element, attrs) {
      return uiUtils.isAnchor(attrs) ? '<a class="tl-icon-button"><i class="icon" ng-transclude></i></a>' : '<button type="button" class="tl-button_icon-button tl-icon-button">{{disabled}}<i class="icon" ng-transclude></i></button>';
    },
    link: function link($scope, $el, $attrs) {
      var iconEl = $el.find(".icon");
      var buttonEl = $el.find(".tl-button_icon-button");
      var previousIcon = null;
      var authzIfIntra = $attrs['authz-if-intra'];

      // couleur intra
      $attrs.$observe("authzIfIntra", function () {
        iconEl.addClass('green');
      });
      $attrs.$observe("icon", function () {
        var iconName = $attrs["icon"] || "";
        if (previousIcon != null) {
          iconEl.removeClass(previousIcon);
        }
        var fullIcon = iconUtils.getFullName(iconName);
        previousIcon = fullIcon;
        iconEl.addClass(fullIcon);
      });

      /**
       * // todo - un attribut disable...
        // attach before ng-click to stop propagation when disabled
       $el.on('click', function(event) {
          if (this.hasAttribute('disabled')) {
              event.stopImmediatePropagation();
          }
      });
        $attrs.$observe("tlDisabled", (value) => {
            $scope.disabled = value;
          if ($scope.disabled) {
              buttonEl.addClass('disabled');
          } else {
              buttonEl.removeClass('disabled');
          }
       });
       */
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/buttons/tl-icon-button.js
// module id = 2925
// module chunks = 13